import { combineReducers } from '@reduxjs/toolkit';
import ClientCredentials from './ClientCredentials/reducer';
import auth from './auth/reducer';
import Applications from './Applications/reducer';
import Subscriptions from './Subscriptions/reducer';

export default combineReducers({
    ClientCredentials,
    auth,
    Applications,
    Subscriptions,
});